const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/crm/contacts/import/step-2.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Skeleton } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import type { SortingFn } from '@tanstack/react-table';
import Papa from 'papaparse';
import { useImportStore } from './route';
export const Route = createFileRoute('/dash/crm/contacts/import/step-2')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  beforeLoad: () => {
    if (useImportStore.getState().file === null) {
      throw redirect({
        to: '/dash/crm'
      });
    }
  },
  loader: () => {
    const file = useImportStore.getState().file;
    if (file === null) {
      throw new Error('No file found');
    }
    return new Promise<Papa.ParseResult<string[]>>((resolve, reject) => {
      Papa.parse(file, {
        worker: true,
        complete: result => {
          resolve(result as Papa.ParseResult<string[]>);
        },
        error: error => {
          reject(error);
        }
      });
    });
  },
  pendingComponent: () => {
    return <Skeleton variant="rectangular" height="100%" width="100%" animation="wave" />;
  }
});